import { Check, Mail } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface Props {
  onSubmit: (email?: boolean) => void
  onDecline: () => void
  loading: boolean
  // assignTable and newRoom behave like revert/clearTables: simple yes/no confirmation
  kind?: 'time' | 'revert' | 'clearTables' | 'assignTable' | 'newRoom'
}

const MoveBookingDialogFooter = ({ onDecline, onSubmit, loading, kind = 'time' }: Props) => {
  if (kind === 'time') {
    return (
      <div className="flex w-full justify-between">
        <Button variant="outline" onClick={onDecline}>
          Abbrechen
        </Button>
        <div className="flex gap-3">
          <Button
            variant="outline"
            icon={<Mail className="h-4 w-4" />}
            onClick={() => onSubmit(true)}
            loading={loading}
          >
            Speichern mit E-Mail
          </Button>
          <Button
            icon={<Check className="h-4 w-4" />}
            onClick={() => onSubmit(false)}
            loading={loading}
          >
            Speichern
          </Button>
        </div>
      </div>
    )
  }

  // for revert/clearTables we just need a simple confirm/cancel
  return (
    <div className="flex w-full justify-end gap-3">
      <Button variant="outline" onClick={onDecline}>
        Abbrechen
      </Button>
      <Button onClick={() => onSubmit(false)} loading={loading}>
        Ja
      </Button>
    </div>
  )
}

export default MoveBookingDialogFooter
